/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 11/21/17
 * Copyright All Rights Reserved
 */
import identity from 'lodash/fp/identity';
import { createSelector } from 'reselect';

export const currentReportError = createSelector(
  state => state.entities.reports.current.error,
  identity
);

export const currentReportIsSaving = createSelector(
  state => state.entities.reports.current.saving,
  identity
);

export const getReportsLoaded = createSelector(
  state => state.entities.reports.loaded,
  identity
);

export const getReports = createSelector(
  state => state.entities.reports.byId,
  byId => Object.values(byId)
    .filter(report => report.user !== undefined)
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
);
